var map = {
  "./cs.json": [
    "JE",
    [
      "fv"
    ]
  ],
  "./en.json": [
    "Bw7",
    [
      79
    ]
  ],
  "./pl.json": [
    "X05",
    [
      "tba"
    ]
  ],
  "./ru.json": [
    "Yz",
    [
      "mm8"
    ]
  ],
  "./tr.json": [
    "Qz7",
    [
      "y5"
    ]
  ],
  "./ja.json": [
    "wdg",
    [
      "m7"
    ]
  ],
  "./zh.json": [
    "b1",
    [
      9
    ]
  ],
  "./pt-br.json": [
    "vw",
    [
      "h3g"
    ]
  ],
  "./de.json": [
    "Oog",
    [
      "kr"
    ]
  ],
  "./es.json": [
    "IkT",
    [
      "a6"
    ]
  ],
  "./fr.json": [
    "AY",
    [
      "qo"
    ]
  ],
  "./it.json": [
    "QLg",
    [
      "6a"
    ]
  ],
  "./ko.json": [
    "QrC",
    [
      "i3"
    ]
  ],
  "./pt.json": [
    "Xo",
    [
      "tnz"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "ad";
module.exports = __rspack_async_context;
